import { styled, css, Box } from '@mui/material'
import Button from '../Button'
import Grid from '../Grid'
import Heading from '../Heading'
import ItemCard from '../ItemCard'
import { CardWrapper } from '../ItemCard/ItemCard.styles'
import Text from '../Text'

export const ItemListWrapper = styled(Grid)(() => css``)
ItemListWrapper.defaultProps = {
  gap: 8
}

export const ItemListGrid = styled(Grid)(() => css``)
ItemListGrid.defaultProps = {
  gap: 8,
  columns: 2
}

export const HeadingWrapper = styled(Box)(
  () => css`
    padding-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  `
)

export const HeadingText = styled(Heading)(() => css``)

export const HeadingButtonsWrapper = styled(Box)(
  () => css`
    display: flex;
    align-items: center;
    gap: 4px;
  `
)

export const HeadingButton = styled(Button)(() => css``)
HeadingButton.defaultProps = {
  size: 'small',
  variant: 'text'
}

export const ItemListCard = styled(ItemCard)(() => css``)

export const ItemPlaceholder = styled(CardWrapper)(
  ({ horizontal }) => css`
    height: ${horizontal ? '120px' : '250px'};
  `
)

export const ActionText = styled(Text)(
  ({ theme }) => css`
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
    color: ${theme.palette.primary.main};
  `
)

export const EmptyMessageWrapper = styled(Box)(
  () => css`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  `
)
